import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../../../components/footer";
import PageBackgroundPattern from "../../../components/PageBackgroundPattern";
import CompararFilters from "../components/CompararFilters";
import CompararHeader from "../components/CompararHeader";
import CompararProfilesSection from "../components/CompararProfilesSection";
import CompararStatsSection from "../components/CompararStatsSection";
import useCompararData from "../hooks/useCompararData";

function Comparar() {
    const location = useLocation();
    const initialSelection = useMemo(() => {
        const searchParams = new URLSearchParams(location.search);

        return {
            leftName: searchParams.get("leftName") || "",
            leftRole: searchParams.get("leftRole") || "jugador",
        };
    }, [location.search]);

    const {
        isLoading,
        isError,
        listadoComparar,
        leftName,
        setLeftName,
        rightName,
        setRightName,
        leftRole,
        setLeftRole,
        rightRole,
        setRightRole,
        leftScope,
        setLeftScope,
        rightScope,
        setRightScope,
        leftScopeOptions,
        rightScopeOptions,
        mode,
        setMode,
        canUsePromedios,
        leftProfile,
        rightProfile,
    } = useCompararData(initialSelection);

    useEffect(() => {
        document.title = "Comparar";
    }, []);

    return (
        <div className="relative min-h-screen overflow-hidden bg-[#062a1a] pt-16">
            <PageBackgroundPattern />
            <main className="relative z-10 max-w-7xl mx-auto w-full px-3 sm:px-4 md:px-10 pt-2 pb-6 sm:pb-8 md:pb-10">
                <CompararHeader />

                <CompararFilters
                    options={listadoComparar}
                    leftName={leftName}
                    setLeftName={setLeftName}
                    rightName={rightName}
                    setRightName={setRightName}
                    leftRole={leftRole}
                    setLeftRole={setLeftRole}
                    rightRole={rightRole}
                    setRightRole={setRightRole}
                    leftScope={leftScope}
                    setLeftScope={setLeftScope}
                    rightScope={rightScope}
                    setRightScope={setRightScope}
                    leftScopeOptions={leftScopeOptions}
                    rightScopeOptions={rightScopeOptions}
                    leftProfile={leftProfile}
                    rightProfile={rightProfile}
                />

                {isLoading ? (
                    <div className="rounded-xl border border-white/10 bg-[#102216] p-6 sm:p-8 text-center text-slate-300 text-sm sm:text-base font-medium mb-6 sm:mb-8">
                        Cargando comparación...
                    </div>
                ) : null}

                {isError && !isLoading ? (
                    <div className="rounded-xl border border-red-400/30 bg-red-950/20 p-6 sm:p-8 text-center text-red-200 text-sm sm:text-base font-medium mb-6 sm:mb-8">
                        No se pudieron cargar los datos de comparación en este momento.
                    </div>
                ) : null}

                {!isLoading && !isError && (!leftName || !rightName) ? (
                    <div className="rounded-xl border border-white/10 bg-[#102216] p-6 sm:p-8 text-center text-slate-300 text-sm sm:text-base font-medium mb-6 sm:mb-8">
                        Seleccioná dos perfiles para ver la comparación.
                    </div>
                ) : null}

                {!isLoading && !isError && leftName && rightName && leftName === rightName ? (
                    <div className="rounded-xl border border-red-400/30 bg-red-950/20 p-6 sm:p-8 text-center text-red-200 text-sm sm:text-base font-medium mb-6 sm:mb-8">
                        Seleccionaste el mismo perfil dos veces. Elegí dos perfiles distintos para comparar.
                    </div>
                ) : null}

                {!isLoading && !isError && leftProfile && rightProfile && leftName !== rightName ? (
                    <>
                        <CompararProfilesSection
                            leftProfile={leftProfile}
                            rightProfile={rightProfile}
                            leftRole={leftRole}
                            rightRole={rightRole}
                            leftScope={leftScope}
                            rightScope={rightScope}
                            leftName={leftName}
                            rightName={rightName}
                        />

                        <CompararStatsSection
                            leftProfile={leftProfile}
                            rightProfile={rightProfile}
                            leftRole={leftRole}
                            rightRole={rightRole}
                            leftScope={leftScope}
                            rightScope={rightScope}
                            mode={mode}
                            setMode={setMode}
                            canUsePromedios={canUsePromedios}
                        />
                    </>
                ) : null}
            </main>

            <div className="relative z-10">
                <Footer />
            </div>
        </div>
    );
}

export default Comparar;